var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cimba-header',{attrs:{"appLinks":_vm.appLinks,"appId":_vm.appId,"appTitle":_vm.appTitle,"documentationUrl":_vm.documentationUrl,"mailToAddress":_vm.mailToAddress,"onLogOutClicked":_vm.logoutAction,"profile":_vm.profile}})
}
var staticRenderFns = []

export { render, staticRenderFns }